export type InsuranceValidationMode = 'onBlur' | 'onChange';

export interface InsuranceFieldState {
  error?: {
    message?: string;
  };
  isDirty: boolean;
  isTouched: boolean;
}

export const getInsuranceFieldErrorProps = (
  fieldState: InsuranceFieldState,
  validationMode: InsuranceValidationMode,
  forceShowError = false,
) => {
  const showError =
    !!fieldState.error &&
    (forceShowError ||
      (validationMode === 'onBlur'
        ? fieldState.isTouched
        : fieldState.isDirty || fieldState.isTouched));

  return {
    error: showError,
    helperText: showError ? fieldState.error?.message : undefined,
  };
};
